export default () => ({
  popper: ({ onDialog }) => {
    return {
      zIndex: onDialog ? '111111' : '1111',
    }
  },
})
